import React, {useState, useEffect} from 'react';
import {Carousel, List, Pagination, Input, Button} from 'antd';
import history from "../../../libs/history";
import styles from '../layout.module.less'

import banner1 from './banner1.png'
import cart from './cart.png'

import {observer} from "mobx-react";
import store from '../store'
import cartStore from "../../cart/store"

// the hook
import { useTranslation } from 'react-i18next';

export default observer(function (props) {
  const { t, i18n } = useTranslation();

  console.log(props,'props');

  // useEffect(() => {
  //   store.records.length === 0 && store.fetchRecords(i18n.language);
  // }, [])

  useEffect(() => {
    store.fetchRecords(i18n.language);
  }, [i18n.language])

  //加入购物车
  const handleBuy = (record = {}, isBuy = true) => {
    cartStore.addRecord(record.id, isBuy ? record.saleCatalog : record.leaseCatalog ).then(v => true)
  }

  const listData = [...store.records]

  return (
    <React.Fragment>
      <Carousel className={styles.carousel}>
        <div>
          <a href="#" className={styles.alink} style={{backgroundImage: `url(${banner1})`}}/>
        </div>
        {/* <div>
          <a href="" className={styles.alink} style={{backgroundImage: `url(${banner1})`}}/>
        </div> */}
      </Carousel>
      <div className='search_container'>
        <Input style={{width:'250px',marginRight:'24px'}} value={store.keywords} onChange={e=>store.keywords = e.target.value} placeholder='输入关键字搜索'/>
        <Button type='primary' onClick={()=>store.fetchRecords()}>查 询</Button>
      </div>
      <div className={styles.lists}>
        <List
          className={styles.list}
          header=''
          footer=''
          // grid={{column: 4, gutter: 20}}
          dataSource={store.records}
          split={false}
          pagination={false}
          loading={store.isFetching}
          renderItem={(item, index) => (
            <List.Item>

              <div key={'goods' + item['id']} className={[styles.item].join(" ")} title={item['name']}>
                <div onClick={() => {
                  history.push('/goods/detail?id=' + item['id'])
                }}>

                  <div className={styles.img} style={{backgroundImage: 'url(' + item['thumb'] + ')'}}/>
                  <div className={styles.name}>{item['name']}</div>
                  <div className={styles.desc}>{item['brand']} {item['factoryCode']}</div>
                </div>

                <div className={styles.btnGroup}>
                  {
                    item['leaseAble'] ? (
                      <a className={styles.btn} onClick={v => handleBuy(item, false)}>{t('租赁')}</a>) : ''
                  }
                  {
                    item['saleAble'] ? (
                      <a className={styles.btn} onClick={v => handleBuy(item, true)}>{t('采购')}</a>) : ''
                  }
                </div>
              </div> 
              {/* {
                index % 8 === 4 ? (<div className={styles.itemBg}/>) : null
              } */}

            </List.Item>
          )}
        />
        {
          store.records.length === 0 ? null : (
            <div style={{width:'6.1042rem', margin: '0 auto', textAlign: 'right'}}>
              <Pagination
                current={store.page}
                pageSize={store.pageSize}
                total={store.pageTotal}
                showTotal={total => `共 ${total} 条`}
                showSizeChanger={false}
                onChange={store.pageChange}
                />
            </div>
          )
        }
        <div className='cart_container'>
          <img onClick={() => {
          history.push('/cart')
        }} src={cart} alt="" />
        </div>
      </div>
    </React.Fragment>
  )

})

